import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getSalesPaymentHistoryReport as getSalesPaymentHistoryReportApi,
  getSalesCommission as getSalesCommissionApi,
} from "../../helpers/ServiceHelpers/backend_helper";

//getPagedPaymentHistoryReport
export const getSalesPaymentHistoryReport = createAsyncThunk(
  "payment/getSalesPaymentHistoryReport",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSalesPaymentHistoryReportApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

//getPagedCommission
export const getSalesCommission = createAsyncThunk(
  "payment/getSalesCommission",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = await getSalesCommissionApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
